import { useEffect, useState } from "react";
import { PageHeader, Section, DividerGold } from "@/components/layout/Section";
import api from "@/lib/api";
import { motion } from "framer-motion";
import { IMAGES } from "@/constants/branding";

export default function Devotional() {
  const [today, setToday] = useState(null);
  const [all, setAll] = useState([]);

  useEffect(() => {
    api.get("/devotionals/today").then((r) => setToday(r.data));
    api.get("/devotionals").then((r) => setAll(r.data));
  }, []);

  return (
    <div data-testid="devotional-page">
      <PageHeader
        kicker="Daily Devotional"
        title="A word for today."
        subtitle="Fresh Spirit-inspired reflections to strengthen your walk with Christ every day."
      />

      {today && (
        <Section>
          <div className="grid lg:grid-cols-12 gap-14 items-start">
            <div className="lg:col-span-5">
              <div className="aspect-[4/5] rounded-[2.5rem] overflow-hidden shadow-xl">
                <img src={IMAGES.bible} alt="Open Bible" className="w-full h-full object-cover" />
              </div>
            </div>
            <div className="lg:col-span-7">
              <div className="kicker mb-4">Today · {new Date(today.date).toLocaleDateString()}</div>
              <h2 className="font-serif text-4xl sm:text-5xl text-royal-800 leading-tight">{today.title}</h2>
              <p className="mt-6 scripture text-lg">"{today.scripture}"</p>
              <p className="text-xs uppercase tracking-widest text-gold-500">{today.scripture_ref}</p>

              <div className="mt-8 text-slate-700 leading-relaxed whitespace-pre-line">{today.body}</div>

              {today.prayer && (
                <div className="mt-10 p-6 rounded-2xl border border-gold/30 bg-gold/5">
                  <div className="text-xs uppercase tracking-widest text-gold-500">Prayer</div>
                  <p className="mt-2 scripture text-slate-700">{today.prayer}</p>
                </div>
              )}
              <div className="mt-6 text-sm text-slate-500">— {today.author}</div>
            </div>
          </div>
        </Section>
      )}

      <Section className="bg-slate-50/70 rounded-[3rem] mx-4">
        <div className="text-center max-w-xl mx-auto">
          <div className="kicker justify-center mb-4">Archive</div>
          <h2 className="font-serif text-4xl text-royal-800">Previous Devotionals</h2>
          <DividerGold className="mt-6" />
        </div>
        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {all.slice(1).map((d, i) => (
            <motion.article
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              key={d.id}
              className="card-soft p-8"
              data-testid={`devotional-archive-${i}`}
            >
              <div className="text-xs uppercase tracking-widest text-gold-500">{new Date(d.date).toLocaleDateString()}</div>
              <h3 className="mt-2 font-serif text-2xl text-royal">{d.title}</h3>
              <p className="mt-3 scripture text-sm">"{d.scripture}"</p>
              <p className="mt-4 text-slate-600 text-sm leading-relaxed line-clamp-4">{d.body}</p>
            </motion.article>
          ))}
          {all.length <= 1 && (
            <div className="col-span-full text-center text-slate-500 py-12">More devotionals coming soon.</div>
          )}
        </div>
      </Section>
    </div>
  );
}
